import { render, staticRenderFns } from "./downstreamInvoiceIndex.vue?vue&type=template&id=9596c59a&scoped=true"
import script from "./downstreamInvoiceIndex.vue?vue&type=script&lang=js"
export * from "./downstreamInvoiceIndex.vue?vue&type=script&lang=js"
import style0 from "./downstreamInvoiceIndex.vue?vue&type=style&index=0&id=9596c59a&prod&scoped=true&lang=css"
import style1 from "./downstreamInvoiceIndex.vue?vue&type=style&index=1&id=9596c59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9596c59a",
  null
  
)

export default component.exports